import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useRevokeInvitation } from "@/hooks/useRevokeInvitation";

interface RevokeInvitationDialogProps {
  invitationId: string;
  email: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RevokeInvitationDialog({
  invitationId,
  email,
  open,
  onOpenChange,
}: RevokeInvitationDialogProps) {
  const revokeInvitation = useRevokeInvitation();

  const handleRevoke = async () => {
    try {
      await revokeInvitation.mutateAsync(invitationId);
      onOpenChange(false);
    } catch {
      // Error handled by mutation onError
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Revoke Invitation</DialogTitle>
          <DialogDescription>
            Are you sure you want to revoke the invitation for{" "}
            <span className="font-medium text-foreground">{email}</span>? They
            will no longer be able to accept the invitation.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={revokeInvitation.isPending}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={handleRevoke}
            disabled={revokeInvitation.isPending}
          >
            {revokeInvitation.isPending && (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            )}
            {revokeInvitation.isPending ? "Revoking..." : "Revoke Invitation"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
